import { DrawToolbar } from "components/boundary";
import { ClipConfigProps, ClipStepsControlProps } from "../../clip-menu";
import { BoundaryToolProps } from "./define-boundary";

export const DrawComponent = (
  props: ClipConfigProps & ClipStepsControlProps & BoundaryToolProps
) => {
  return (
    <div className="flex flex-col gap-4 h-full">
      <p className="text-sm text-muted-foreground">
        Use the drawing tools below to draw a boundary
      </p>
      <DrawToolbar
        draw={props.draw}
        currentMode={props.currentMode}
        onModeChange={props.setCurrentMode}
      />
    </div>
  );
};
